<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="credential_dialog"
      max-width="800"
      persistent
    >
      <v-card>
        <v-layout wrap v-show="credencial_info.front" v-if="is_admin()">
          <v-flex xs12 sm12 md12 text-md-right text-sm-right text-xs-right>
            <v-btn flat icon color="blue darken-1"
              @click="print_credential_front_back(credencial_info.front, credencial_info.back)"
            >
              <v-icon>badge</v-icon>
            </v-btn>
          <v-divider class="ma-0"/>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs6 sm6 md6 v-show="credencial_info.front">
            <img :src="this.credencial_image(credencial_info.front)" style="width: 50%"/>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat="flat"
                v-on:click="print_credential(credencial_info.front)">
              Frente
            </v-btn>
          </v-flex>
          <v-flex xs6 sm6 md6 v-show="credencial_info.back">
            <img :src="this.credencial_image(credencial_info.back)" style="width: 50%"/>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat="flat"
                v-on:click="print_credential(credencial_info.back)">
              Reverso
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat" @click="close_credential_dialog">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm_deleted_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text v-if="this.licencia_info.licencia_id">
          ¿Está seguro que desea eliminar la licencia de: <span class="font-weight-bold">{{`${this.licencia_info.nombre}`}}</span>?
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="confirm_deleted_dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="delete_licencia_confirm"
                 v-if="this.licencia_info.licencia_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm6 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            />
          </v-card-title>
        </v-flex>
        <v-flex xs12 sm6 md1 class="pt-4">
          <v-btn color="primary" dark @click.prevent="agregar_licencia()"
            v-show="add_btn === true" :disabled="!add_btn">
            Agregar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="licencias"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="is_loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left" v-if="props.item.residente_id !== null">Residente</td>
          <td class="text-xs-left" v-else>Servicio Doméstico</td>
          <td class="text-xs-left">{{ props.item.folio }}</td>
          <td class="text-xs-left">{{ props.item.nombre_conductor }}</td>
          <td class="text-xs-left">{{ props.item.n_vivienda }}</td>
          <td class="text-xs-left">{{ props.item.vigencia }}</td>
          <td class="text-xs-left">
            <!--
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="mostrar_licencia(props.item.id)" class="mr-2" small
                  v-on="on" v-show="view_btn === true" :disabled="!view_btn">
                  visibility
                </v-icon>
              </template>
              <span>Detalles de la licencia</span>
            </v-tooltip>
            -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="editar_licencia(props.item.id)" class="mr-2" small
                  v-on="on" v-show="edit_btn === true" :disabled="!edit_btn">
                  edit
                </v-icon>
              </template>
              <span>Editar Licencia</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon @click.prevent="generate_credential(props.item.id)" class="mr-2" small
                  v-on="on" v-show="print_btn === true" :disabled="!print_btn">
                  print
                </v-icon>
              </template>
              <span>Licencia</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="show_delete_dialog(props.item.id, props.item.nombre_conductor)"
                  v-on="on" v-show="delete_btn === true" :disabled="!delete_btn" class="mr-2" small>
                  delete
                </v-icon>
              </template>
              <span>Eliminar Licencia</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    delete_btn: false,
    print_btn: false,
    edit_btn: false,
    view_btn: false,
    add_btn: false,
    credential_dialog: false,
    confirm_deleted_dialog: false,
    credencial_info: {},
    licencia_info: {},
    licencias: [],
    totalItems: 0,
    pagination: {},
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    valid: true,
    headers: [
      { text: 'id', value: 'id', sortable: false },
      { text: 'Tipo', value: 'tipo', sortable: false },
      { text: 'Folio', value: 'folio', sortable: true },
      { text: 'Conductor', value: 'nombre', sortable: false },
      { text: 'Vivienda', value: 'vivienda', sortable: false },
      { text: 'Vigente Hasta', value: 'vigencia', sortable: false },
      { text: 'Acciones', value: 'acciones', sortable: false },
    ],
  }),
  computed: {
    is_loading() {
      return this.$store.getters['listadoLicencias/is_loading'];
    },
    alertType() {
      return this.$store.getters['listadoLicencias/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['listadoLicencias/alertContainerMessage'];
      console.log(this.alertMessage);
    },
    alert() {
      return this.$store.getters['listadoLicencias/alertContainer'];
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.search !== '' && this.search != null) {
          this.getDataFromApi()
            .then((data) => {
              this.licencias = data.licencias;
              this.totalItems = data.total;
            });
        }
      },
      deep: true,
    },
    search(val) {
      if (val === '') {
        this.licencias = [];
        this.totalItems = 0;
      } else {
        this.getDataFromApi()
          .then((data) => {
            this.licencias = data.licencias;
            this.totalItems = data.total;
          });
      }
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
  },
  methods: {
    delete_licencia_confirm() {
      this.confirm_deleted_dialog = false;
      this.$store.dispatch('listadoLicencias/deleteLicencia', this.licencia_info.licencia_id).then(() => {
        this.getDataFromApi().then((data) => {
          this.licencias = data.licencias;
          this.totalItems = data.total;
        });
      });
      this.licencia_info = {};
      this.$store.commit('listadoLicencias/clearAlertDialog');
    },
    show_delete_dialog(id, nombreConductor) {
      this.licencia_info = { licencia_id: id, nombre: nombreConductor };
      this.confirm_deleted_dialog = true;
    },
    editar_licencia(licenciaId) {
      this.$store.commit('listadoLicencias/clearAlertDialog');
      this.$router.push({ name: 'editar_licencia', params: { id: licenciaId } });
    },
    agregar_licencia() {
      this.$store.commit('listadoLicencias/clearAlertDialog');
      this.$router.push({ name: 'agregar_licencia' });
    },
    mostrar_licencia(licenciaId) {
      this.$store.commit('listadoLicencias/clearAlertDialog');
      this.$router.push({ name: 'detalles_licencia', params: { id: licenciaId } });
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, page, rowsPerPage } = this.pagination;
        let { descending } = this.pagination;
        if (descending === null) {
          descending = false;
        }
        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('listadoLicencias/fetchLicencias', formdata)
          .then((data) => {
            // console.log(data);
            this.loading = false;
            const { licencias, total } = data;
            this.$store.commit('listadoLicencias/fetchedLicencias');
            resolve({
              licencias,
              total,
            });
          });
      });
    },
    credencial_image(val) {
      let encoded = '';
      const extension = 'png';
      if (typeof val !== 'undefined') {
        encoded = val;
      } else {
        encoded = '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';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
    generate_credential(id) {
      const formData = {
        licencia_id: id,
      };
      this.$store.dispatch('listadoLicencias/generateCredential', formData).then((data) => {
        this.credencial_info = data;
      });
      this.credential_dialog = true;
    },
    print_credential_front_back(front, back) {
      const base = 'data:image/png;base64, ';
      const srcimgfront = base.concat(front);
      const srcimgback = base.concat(back);
      const mywindow = window.open('', 'PRINT');
      const isChrome = Boolean(mywindow.chrome);
      mywindow.document.write('<html><body>');
      mywindow.document.write(`<img src="${srcimgfront}" width="195" style="border-style: dashed none dashed dashed;border-width: 2px;border-color: #000;padding: 5px;">`);
      mywindow.document.write(`<img src="${srcimgback}" width="195" style="border: 2px dashed #000; padding: 5px;">`);
      mywindow.document.write('</body></html>');
      if (isChrome) {
        setTimeout(() => { // wait until all resources loaded
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10
          mywindow.print(); // change window to winPrint
          mywindow.close(); // change window to winPrint
        }, 250);
      } else {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
      }

      return true;
    },
    print_credential(val) {
      const base = 'data:image/png;base64, ';
      const srcimg = base.concat(val);
      const mywindow = window.open('', 'PRINT');
      const isChrome = Boolean(mywindow.chrome);
      mywindow.document.write('<html><body>');
      mywindow.document.write(`<img src="${srcimg}" width="159" height="249">`);
      mywindow.document.write('</body></html>');
      if (isChrome) {
        setTimeout(() => { // wait until all resources loaded
          mywindow.document.close(); // necessary for IE >= 10
          mywindow.focus(); // necessary for IE >= 10
          mywindow.print(); // change window to winPrint
          mywindow.close(); // change window to winPrint
        }, 250);
      } else {
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
      }

      return true;
    },
    close_credential_dialog() {
      this.credencial_info = {};
      this.credential_dialog = false;
    },
    is_admin() {
      if (['admin'].includes(this.user_login_role)) {
        return true;
      }
      return false;
    },
  },
  created() {

    console.log(this.alertMessage);
    this.user_login_role = getJWTData().user_claims.role;
    if (['admin', 'admin_eko', 'censo_residentes', 'atencion_residentes', 'avisos', 'censo_domesticos', 'censo_mascotas', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
      if (['admin', 'admin_eko', 'censo_residentes'].includes(this.user_login_role)) {
        this.add_btn = true;
        // this.view_btn = true;
        this.edit_btn = true;
        this.print_btn = true;
        this.delete_btn = true;
      } else if (['censo_domesticos', 'censo_mascotas', 'atencion_residentes', 'avisos', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
        // this.view_btn = true;
      }
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  mounted() {

  },
};
</script>
